<template>
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="4"
      width="16"
      height="11.6364"
      stroke="currentColor"
      :stroke-width="bigger ? '0.8' : '1.5'"
    />
    <path
      d="M18 5.45533C18 5.40383 14.4183 8.60644 10 10.182C5.58172 8.60644 2 5.40383 2 5.45533"
      stroke="currentColor"
      :stroke-width="bigger ? '0.8' : '1.5'"
    />
  </svg>
</template>
<script>
export default {
  name: 'IconMail',
  props: {
    bigger: {
      type: Boolean,
      default: false
    }
  }
}
</script>
